var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlagIcon = function SvgFlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.667 14.444a.667.667 0 0 0 1.333 0V9.658a7.2 7.2 0 0 1 2.228 0c.556.088.924.215 1.312.35l.007.002c.37.128.752.26 1.264.345q.482.08.981.08c.97 0 1.988-.227 3.037-.678a.67.67 0 0 0 .503-.647V2.889a.665.665 0 0 0-.981-.588c-1.139.613-2.205.852-3.169.706-.438-.066-.762-.194-1.138-.343l-.003-.001c-.418-.166-.89-.354-1.583-.485A8 8 0 0 0 4 2.11v-.555a.667.667 0 0 0-1.333 0z",
    clipRule: "evenodd"
  })));
};
export default SvgFlagIcon;